import { createContext } from 'react';
import type { Context } from 'react';

import type { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import type { ExtractInjectionAPI, TypeAheadHandler } from '@atlaskit/editor-common/types';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import type { TypeAheadPlugin } from '../../typeAheadPluginType';

export type TypeAheadContextValue = {
	api: ExtractInjectionAPI<TypeAheadPlugin> | undefined;
	editorView: EditorView;
	inputMethod: INPUT_METHOD.QUICK_INSERT;
	onClose: () => void;
	query: string;
	triggerHandler: TypeAheadHandler;
};

export const TypeAheadContext: Context<TypeAheadContextValue | null> =
	createContext<TypeAheadContextValue | null>(null);
